import random from 'toxilibs/random.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'arrays_setter',
    dependencies: [
        'levels/variables',
        'levels/length'
    ]
})


const randomLetter = random.unmistakableLetter



level.addQuestion({
    generator: function (q) {
        let a = []
        const l = random.intBetween(3, 7)
        for (let i = 0; i < l; i++) {
            a.push(random.pick(random.intBetween(1, 9), randomLetter()))
        }
        q.addJSCode(
            'let a = ' + q.codeArrayToDisplay(a)
            + '\na.push(\'' + randomLetter() + '\')'
            + '\na[' + a.length + ']'
        )
    },
    times: 2
})


level.addQuestion({
    generator: function (q) {
        let a = []
        const l = random.intBetween(3, 7)
        for (let i = 0; i < l; i++) {
            a.push(random.pick(random.intBetween(1, 9), randomLetter()))
        }
        q.addJSCode(
            'let a = ' + q.codeArrayToDisplay(a)
            + '\na.push(\'' + randomLetter() + '\')'
            + '\na.length'
        )
    },
    times: 2
})




level.addQuestion({
    generator: function (q) {
        let a = []
        const l = random.intBetween(3, 7)
        for (let i = 0; i < l; i++) {
            a.push(random.pick(random.intBetween(1, 9), randomLetter()))
        }
        q.addJSCode(
            'let a = ' + q.codeArrayToDisplay(a)
            + '\na.push(\'' + randomLetter() + '\')'
            + '\na[a.length - 1]'
        )
    },
    times: 2
})


export default level

